module.exports = __webpack_public_path__ + "img/article2.23c0bf81.png";